import { elements, html, ref, slotted } from "@microsoft/fast-element";
/**
 * The template for the {@link @fabric-msft/fabric-web#(Carousel:class)} component.
 * @public
 */
export function carouselTemplate() {
    return html `
    <template ?no-animation="${(x) => x.disableAnimation}">
      <div class="navigation">
        <div class="header" ${ref("header")}>
          <slot name="header"></slot>
        </div>
        <div class="button-container">
          <slot name="prev-button" ${slotted("prevButton")}></slot>
          <slot name="next-button" ${slotted("nextButton")}></slot>
        </div>
      </div>

      <div class="viewport" role="region" ${ref("viewportRef")}>
        <slot
          ${slotted({ property: "slottedCarouselItems", filter: elements() })}
        ></slot>
      </div>
    </template>
  `;
}
export const template = carouselTemplate();
//# sourceMappingURL=carousel.template.js.map